//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    supervisors: {
      type: Array,
      default: () => [],
    },
    currentSupervisorId: {
      type: Number,
      default: null,
    },
    showValidation: {
      // Nueva prop para saber cuándo mostrar validación
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: undefined,
      init: false,
    }
  },
  computed: {
    type() {
      if (!this.showValidation || !this.init) {
        return ''
      }
      return !this.selected ? 'is-danger' : 'is-success'
    },
    showError() {
      return this.showValidation && this.init && !this.selected
    },
  },
  watch: {
    currentSupervisorId(newId) {
      if (newId) {
        this.selected = this.supervisors.find((supervisor) => {
          const result = supervisor.user?.id === newId
          return result
        })
      }
    },
  },
  methods: {
    handleSelect(selected) {
      this.init = true
      this.selected = selected
      this.$emit('supervisor-selected', selected)
    },
    handleBlur() {
      this.init = true // Activa la validación visual
    },
  },
}
